"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.ReduxLink = exports.subscriptionResult = exports.subscriptionInit = exports.mutationResult = exports.mutationInit = exports.queryResult = exports.queryInit = exports.APOLLO_SUBSCRIPTION_RESULT = exports.APOLLO_SUBSCRIPTION_INIT = exports.APOLLO_MUTATION_RESULT = exports.APOLLO_MUTATION_INIT = exports.APOLLO_QUERY_RESULT = exports.APOLLO_QUERY_INIT = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _apolloLink = require("apollo-link");

var _apolloUtilities = require("apollo-utilities");

var APOLLO_QUERY_INIT = 'APOLLO_QUERY_INIT';
exports.APOLLO_QUERY_INIT = APOLLO_QUERY_INIT;
var APOLLO_QUERY_RESULT = 'APOLLO_QUERY_RESULT';
exports.APOLLO_QUERY_RESULT = APOLLO_QUERY_RESULT;
var APOLLO_MUTATION_INIT = 'APOLLO_MUTATION_INIT';
exports.APOLLO_MUTATION_INIT = APOLLO_MUTATION_INIT;
var APOLLO_MUTATION_RESULT = 'APOLLO_MUTATION_RESULT';
exports.APOLLO_MUTATION_RESULT = APOLLO_MUTATION_RESULT;
var APOLLO_SUBSCRIPTION_INIT = 'APOLLO_SUBSCRIPTION_INIT';
exports.APOLLO_SUBSCRIPTION_INIT = APOLLO_SUBSCRIPTION_INIT;
var APOLLO_SUBSCRIPTION_RESULT = 'APOLLO_SUBSCRIPTION_RESULT';
exports.APOLLO_SUBSCRIPTION_RESULT = APOLLO_SUBSCRIPTION_RESULT;

var payload = function payload(_ref) {
  var operationName = _ref.operationName,
      variables = _ref.variables,
      query = _ref.query;
  return {
    operationName: operationName,
    variables: variables,
    document: query
  };
};

var initAction = function initAction(type) {
  return function (operation) {
    return (0, _extends2.default)({
      type: type
    }, payload(operation));
  };
};

var resultAction = function resultAction(type) {
  return function (result, operation) {
    return (0, _extends2.default)({
      type: type,
      result: result
    }, payload(operation));
  };
};

var queryInit = initAction(APOLLO_QUERY_INIT);
exports.queryInit = queryInit;
var queryResult = resultAction(APOLLO_QUERY_RESULT);
exports.queryResult = queryResult;
var mutationInit = initAction(APOLLO_MUTATION_INIT);
exports.mutationInit = mutationInit;
var mutationResult = resultAction(APOLLO_MUTATION_RESULT);
exports.mutationResult = mutationResult;
var subscriptionInit = initAction(APOLLO_SUBSCRIPTION_INIT);
exports.subscriptionInit = subscriptionInit;
var subscriptionResult = resultAction(APOLLO_SUBSCRIPTION_RESULT);
exports.subscriptionResult = subscriptionResult;

var isQuery = function isQuery(op) {
  return op === 'query';
};

var isMutation = function isMutation(op) {
  return op === 'mutation';
};

var isSubscription = function isSubscription(op) {
  return op === 'subscription';
};

var ReduxLink = function (_ApolloLink) {
  (0, _inheritsLoose2.default)(ReduxLink, _ApolloLink);

  function ReduxLink(store) {
    var _this;

    _this = _ApolloLink.call(this) || this;
    _this.store = store;
    return _this;
  }

  var _proto = ReduxLink.prototype;

  _proto.request = function request(operation, forward) {
    var _this2 = this;

    var observer = forward(operation);
    var definition = (0, _apolloUtilities.getMainDefinition)(operation.query);

    if (isQuery(definition.operation)) {
      this.store.dispatch(queryInit(operation));
    } else if (isMutation(definition.operation)) {
      this.store.dispatch(mutationInit(operation));
    } else if (isSubscription(definition.operation)) {
      this.store.dispatch(subscriptionInit(operation));
    }

    return observer.map(function (result) {
      if (isQuery(definition.operation)) {
        _this2.store.dispatch(queryResult(result, operation));
      } else if (isMutation(definition.operation)) {
        _this2.store.dispatch(mutationResult(result, operation));
      } else if (isSubscription(definition.operation)) {
        _this2.store.dispatch(subscriptionResult(result, operation));
      }

      return result;
    });
  };

  return ReduxLink;
}(_apolloLink.ApolloLink);

exports.ReduxLink = ReduxLink;
var _default = ReduxLink;
exports.default = _default;